import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { Children, cloneElement, isValidElement, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { LoadPricingThunk } from "Root/profile/redux/thunkCreators/orders/pricing";
import LoadMissingAddonsThunk from "Root/profile/redux/thunkCreators/products/missingAddons";
import { LoadUserCartThunk } from "Root/profile/redux/thunkCreators/products/userCart";
const SubscriptionContainer = ({ children, loggedIn, hasOrdered }) => {
    const history = useHistory();
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const fetchAllData = async () => {
        if (loggedIn && hasOrdered) {
            await Promise.all([
                dispatch(LoadUserCartThunk()),
                dispatch(LoadMissingAddonsThunk()),
                dispatch(LoadPricingThunk()),
            ]);
        }
    };
    const moveTo = () => {
        if (!pathname.includes("app")) {
            window.location.href = "/app/subscription/";
        }
        else {
            history.push("/app/subscription/");
        }
    };
    const childrenWithProps = Children.map(children, (child) => {
        if (isValidElement(child)) {
            return cloneElement(child, {
                ...child.props,
                moveTo,
            });
        }
        return child;
    });
    useEffect(() => {
        fetchAllData();
    }, []);
    return _jsx(_Fragment, { children: childrenWithProps });
};
export default SubscriptionContainer;
